import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { DraftPolicy, DraftPreface } from 'views/App/Portal/Policy/_types/manuals/draft';

export type DistributableChange = {
  id: string;
  lastDistributionAt: string;
  title: string;
  type: 'POLICY' | 'PREFACE';
  updatedAt: string;
  contentChange: 'CONTENT' | 'RELEASE_NOTE' | 'GUIDE_SHEET';
};
export type DistributableChanges = { content: DistributableChange[]; };

export default function useDistributableChanges(
  manualId?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<DistributableChanges, Error>(
    ['distributable_changes', manualId],
    async () => {
      const url = `${baseApiUrl()}/lexiverse-manual-api/v1/manuals/${manualId}/distributable-changes`;

      const data = await fetcher({
        method: 'get',
        url,
      }).catch((err) => {
        onError?.(err);
      });

      return data;
    },
    {
      ...options,
      enabled: !!manualId,
    }
  );
}
